<template>
    <div class="share-button">
        <i class="icon-share"></i>
        {{ $t("general.share") }}
    </div>
</template>
<script lang="ts">
export default {
    name: "ShareButton"
};
</script>
<style scoped>
.share-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
    font-size: 2em;
    background-color: var(--secondary);
    color: var(--buttonTextColor);
    font-size: calc(var(--vh) * 2.5);
    border-top-left-radius: 15% 50%;
    border-top-right-radius: 15% 50%;
    border-bottom-left-radius: 15% 50%;
    border-bottom-right-radius: 15% 50%;
    line-height: calc(var(--vh) * 6);
    height: calc(var(--vh) * 6);
}

.icon-share {
    margin-right: 10px;
}
</style>
